/**
 * Convert weather.gov forecast text and icon URL to emoji.
 * Uses \u escapes so the file stays ASCII-safe on Windows editors.
 */
const W = {
  snow: "\u2744\uFE0F",
  rain: "\uD83C\uDF27\uFE0F",
  thunder: "\u26C8\uFE0F",
  wind: "\uD83D\uDCA8",
  clear: "\u2600\uFE0F",
  partly: "\u26C5",
  cloudy: "\u2601\uFE0F",
  fog: "\uD83C\uDF2B\uFE0F",
  freezing: "\uD83E\uDD76",
  default: "\uD83C\uDF24\uFE0F",
};

export function getWeatherEmoji(shortForecast, iconUrl) {
  const forecast = (shortForecast || "").toLowerCase();

  if (forecast.includes("snow")) return W.snow;
  if (forecast.includes("rain") || forecast.includes("showers")) return W.rain;
  if (forecast.includes("thunder") || forecast.includes("storm")) return W.thunder;
  if (forecast.includes("wind") || forecast.includes("windy")) return W.wind;
  if (forecast.includes("clear") || forecast.includes("sunny")) return W.clear;
  if (forecast.includes("partly cloudy") || forecast.includes("partly")) return W.partly;
  if (forecast.includes("cloudy") || forecast.includes("overcast")) return W.cloudy;
  if (forecast.includes("fog") || forecast.includes("haze")) return W.fog;
  if (forecast.includes("freezing")) return W.freezing;

  if (iconUrl) {
    const icon = iconUrl.toLowerCase();
    if (icon.includes("snow")) return W.snow;
    if (icon.includes("rain")) return W.rain;
    if (icon.includes("thunder")) return W.thunder;
    if (icon.includes("wind")) return W.wind;
    if (icon.includes("skc") || icon.includes("clear")) return W.clear;
    if (icon.includes("few")) return W.partly;
    if (icon.includes("sct") || icon.includes("bkn") || icon.includes("cloud")) return W.cloudy;
    if (icon.includes("fog")) return W.fog;
  }

  return W.default;
}

export function formatWeatherDisplay(weatherData) {
  if (!weatherData) return null;

  const emoji = getWeatherEmoji(weatherData.shortForecast, weatherData.icon);
  const high = Math.round(weatherData.highF || 0);
  const low = Math.round(weatherData.lowF || 0);

  return `${emoji} ${high}\u00B0 / ${low}\u00B0`;
}
